import Http from '../index.js'
import Model from '../Model.js'
class Auth extends Model {
  constructor() {
    super('/auth/')
  }

  login(user) {
    return Http.post(`${this.model}login/`, {
      username: user.username,
      password: user.password,
    })
  }

  refresh() {
    return Http.post(`${this.model}refresh/`)
  }

  logout() {
    return Http.post(`${this.model}logout/`)
  }

  me() {
    return Http.get(`${this.model}me/?nested=t`)
  }

  lastAccess() {
    return Http.get(`${this.model}me/last_access/`)
  }

  passwordReset(payload) {
    return Http.post(`${this.model}password_reset/`, payload)
  }

  validateToken(token) {
    return Http.post(`${this.model}password_reset/validate_token/`, { token })
  }

  confirmPassword(token, password) {
    return Http.post(`${this.model}password_reset/confirm/`, {
      token,
      password,
    })
  }

  register(user) {
    return Http.post(`${this.model}register_person/`, user)
  }

  getUserByToken(token) {
    return Http.get(`${this.model}password/get?token=${token}`)
  }

  checkDocument(document) {
    return Http.post(`${this.model}check_document/`, { document })
  }

  registerUser(user) {
    return Http.post(`${this.model}register_user/`, {
      email: user.email,
      username: user.username,
      password: user.password,
    })
  }

  createCompany(payload) {
    return Http.post(`${this.model}register_company/`, payload)
  }

  createPerson(payload) {
    return Http.post(`${this.model}register_person/`, payload)
  }

  linkClientUser(client, user, indicator) {
    return Http.post(`${this.model}link_client_to_user/`, {
      client,
      user,
      indicator,
    })
  }
}

export default new Auth()
